var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFunnelCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27088",
    "data-name": "Group 27088",
    transform: "translate(-1326 -149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27084",
    "data-name": "Group 27084",
    transform: "translate(70 -970)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1564",
    "data-name": "Ellipse 1564",
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    transform: "translate(1256 1119)",
    fill: "#f2f2f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27085",
    "data-name": "Group 27085",
    transform: "translate(681 -67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8159",
    "data-name": "Path 8159",
    d: "M0,0H11V11H0Z",
    transform: "translate(651 222)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M-9579.205,8.152c0-3.874.036-3.687-.082-3.86l-2.631-3.581a.453.453,0,0,1,.37-.712h6.957a.416.416,0,0,1,.34.657s.059-.078-2.105,2.868h0l-.562.767c-.118.171-.084.1-.084,2.806,0,.459-.281.558-1.445,1.433a.471.471,0,0,1-.283.1A.476.476,0,0,1-9579.205,8.152Z",
    transform: "translate(10235 223.701)",
    fill: "#396"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnelCircle);
export default __webpack_public_path__ + "static/media/funnel_circle.0dba3e79149b9503fca822c8812e3cd0.svg";
export { ForwardRef as ReactComponent };